import headerMenu from "./modules/headerMenu";
import scrollToTop from "./modules/scrollToTop";

document.addEventListener('DOMContentLoaded', function (){
    headerMenu();
    scrollToTop();
});

window.addEventListener('scroll', function (){
    scrollToTop();
});
